import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=68689bac&scoped=true"
import script from "./RoleList.vue?vue&type=script&lang=ts"
export * from "./RoleList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68689bac",
  null
  
)

export default component.exports